/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingPeriodMemoryForKubernetesAgent extends models.BaseCostProcessingPeriodMemory {
    getFixupPrototypeFunction() { return CostProcessingPeriodMemoryForKubernetesAgent.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingPeriodMemoryForKubernetesAgent>): CostProcessingPeriodMemoryForKubernetesAgent {
        let obj = Object.assign(new CostProcessingPeriodMemoryForKubernetesAgent(), model);
        CostProcessingPeriodMemoryForKubernetesAgent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingPeriodMemoryForKubernetesAgent>): CostProcessingPeriodMemoryForKubernetesAgent {
        if (!model) return null;
        return CostProcessingPeriodMemoryForKubernetesAgent.newInstance(<CostProcessingPeriodMemoryForKubernetesAgent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingPeriodMemoryForKubernetesAgent) {
        if (!obj) return;

        models.CostProcessingPeriodMemoryForKubernetesAgent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingPeriodMemoryForKubernetesAgent): boolean {
        if (models.BaseCostProcessingPeriodMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingPeriodMemoryForKubernetesAgent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.processed_files === undefined) {
            this.processed_files = 0;
        }
        if (this.processed_workloads === undefined) {
            this.processed_workloads = 0;
        }
        if (typeof this.last_processed_agent_file_date === "string") {
            this.last_processed_agent_file_date = new Date(<string><any>this.last_processed_agent_file_date);
        }
        if (typeof this.last_full_refreshed_on === "string") {
            this.last_full_refreshed_on = new Date(<string><any>this.last_full_refreshed_on);
        }
    }

    /**
     * Number of processed agent files
     */
    processed_files: number;

    /**
     * Number of processed workload objects
     */
    processed_workloads: number;

    /**
     * Datetime of last processed agent file
     */
    last_processed_agent_file_date: Date;

    /**
     * The date of last full refresh of billing period
     */
    last_full_refreshed_on: Date;

}
